import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "delivery-new" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, " Inventurerfassung wird geladen ", -1)

import {nextTick, ref, watch} from 'vue';
import Error from '@/components/Error.vue';
import Picklist, {ApiPicklistState, ApiPicklistType} from '@/model/Picklist';
import router from '@/router';
import DatePicker from '@/components/DatePicker.vue';
import moment from 'moment';
import {doAlert} from '@/util';
import Inventory, {DetailInventoryFilters} from '@/model/Inventory';
import {useSettings} from '@/store/settings';
import {useStorage} from '@/composables/storage';
import useDetailInventoryStore from '@/store/detailInventory';
import useDetailPicklistStore from '@/store/detailPicklist';
import useSubsidiariesStore from '@/store/subsidiaries';
import {VNodeRef} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InventoryCreate',
  setup(__props, { expose: __expose }) {

const detailInventoryStore = useDetailInventoryStore();
const detailPicklistStore = useDetailPicklistStore();
const subsidiariesStore = useSubsidiariesStore();

const date = ref(moment().format('YYYY-MM-DD'));
const formValid = ref(false);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

useStorage(detailInventoryStore,
    (_, route) => route?.params.id ? `Inventur ${route.params.id} bearbeiten` : 'Inventur erstellen',
    (route): DetailInventoryFilters => {
      return {Belegnr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id)};
    });

async function save() {
  console.log('saving');
  const settingsStore = useSettings();
  try {
    const inventory = detailInventoryStore.data;
    form.value?.validate();
    if (!formValid.value) throw new Error('Bitte alle Felder korrekt ausfüllen');
    const picklist = Picklist.fromApi({
      Art: ApiPicklistType.Inventory,
      Picklistnr: inventory?.BelegNr ?? 0,
      BestellNr: null,
      LieferantenNr: null,
      Erstelltam: moment().format('YYYY-MM-DD'),
      Erstelltdurch: '',
      Status: inventory?.Erledigt === 'J' ? ApiPicklistState.Done : ApiPicklistState.Todo,
      Kmsdatum: date.value,
      Kmsuhrzeit: '',
      Kmsprioritaet: '',
      Kmsam: date.value,
      Kmsdurch: '',
      Kmsbediener: useSettings().userShort ?? 'SYS',
      Tour: [],
      Auftraege: [],
      InterneAuftraege: inventory?.convertedPositions ?? [],
    });

    picklist.lieferantName = inventory?.Name ??
    subsidiariesStore.data
        .find((s) => s.NiederlassungNr === settingsStore.selectedSubsidiary)?.Bezeichnung;

    detailPicklistStore.data = picklist;

    router.push({name: 'inventory_pick'}).catch(console.error);
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  }
}
function ruleRequired(val: string|null|undefined): string|true {
  if (!val) return 'erforderlich';

  return true;
}
watch(() => detailInventoryStore.data, async (data: Inventory|null) => {
  if (data) date.value = data.DatumParsed.format('YYYY-MM-DD');
  await nextTick();
  form.value?.validate();
});
watch(form, () => {
  form.value?.validate();
});

__expose({
  Error, DatePicker,
  date,
  formValid,
  form,
  save,
  ruleRequired,
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(detailInventoryStore).loading && !_unref(detailInventoryStore).error)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formValid).value = $event)),
              ref: form.value
            }, {
              default: _withCtx(() => [
                _createVNode(DatePicker, {
                  class: "mt-5",
                  modelValue: date.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
                  label: "Datum",
                  rules: [ruleRequired]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: save,
                  disabled: !formValid.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$route.params.id ? 'Bearbeiten' : 'Erstellen'), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled"])
              ], undefined, true),
              _: 1
            }, 8, ["modelValue"])
          ], undefined, true),
          _: 1
        }))
      : (_unref(detailInventoryStore).error)
        ? (_openBlock(), _createBlock(Error, {
            key: 1,
            module: _unref(detailInventoryStore).$id
          }, null, 8, ["module"]))
        : (_openBlock(), _createBlock(_component_v_overlay, {
            key: 2,
            modelValue: _unref(detailInventoryStore).loading,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(detailInventoryStore).loading) = $event)),
            class: "align-center justify-center",
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_v_progress_circular, { indeterminate: "" })
                      ]),
                      _hoisted_3
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }, 8, ["modelValue"]))
  ]))
}
}

})